const accepted_urls = [
  "/band/profile/select/",
  "/band/profile/delete/",
  "/band/profile/create/",
]

export default async function ({ store, redirect, route }) {
  if (
    !accepted_urls.filter((e) => route.path.includes(e)).length &&
    !store.getters["user/IS_INF"] &&
    !store.state.user.is_staff
  ) {
    await store.dispatch("user/band/FETCH")

    if (store.getters["user/IS_BAND"]) {
      if (!store.state.user.band.id) {
        if (store.state.user.band_set.length === 1) {
          try {
            await store.dispatch(
              "user/band/PATCH",
              store.state.user.band_set[0].id
            )
          } catch (err) {
            console.error(err)
          }
        } else return redirect("/band/profile/select/")
      }
    }
  }
}
